import {columns} from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'
// import {treeActions, treeMutations, treeState} from '../_defaults/tree'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/csiCodes'
export const apiHierarchyEndpoint = '/api/odata/csicodes/hierarchy'
export const namespace = 'csiCodes'
export const clientRoute = '/company/csi-codes'
export const dependencies = []
export const params = {
  include: 'parent',
  // sort: ''
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'description'
const subtitleColumn = undefined
const infoColumns = ['code']
/* --------------------------- */

const state = {
  defaultSort: 'code',
  columns,
  apiEndpoint,
  apiHierarchyEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns,
  supportsParentChild: true,
  // ...treeState
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  // mutations: createMutations(treeMutations),
  actions: createActions()
  // actions: createActions(treeActions)
}
